import Slider from './Slider';
export type { SliderProps } from './Slider.types';
export default Slider;
